import { render, staticRenderFns } from "./SubscriberList.vue?vue&type=template&id=d223124c"
import script from "./SubscriberList.vue?vue&type=script&lang=js"
export * from "./SubscriberList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports